<template>
  <div>
    <b-form @submit.prevent="save">
        <div class="vx-row">
          <div class="vx-col w-full mb-2">
            <b-form-group
                label="Descrição"
                label-for="privacy_form_description">
              <validation-provider
                #default="{ errors }"
                name="Descrição"
                rules="required">
                <complex-editor :editor_data.sync="privacy_form_description"/>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col w-full mb-2">
            <b-form-group
                label="Link Portal Privacidade"
                label-for="privacy_form_link">
              <validation-provider
                #default="{ errors }"
                name="Link Portal Privacidade">
                <b-form-input
                  id="privacy_form_link"
                  v-model="privacy_form_link"
                  :state="errors.length > 0 ? false:null"
                  name="privacy_form_link"
                  class="required"/>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col w-full mb-2">
            <b-form-group
                label="Capacidade civil"
                label-for="privacy_form_message">
              <validation-provider
                #default="{ errors }"
                name="Mensagem">
                <complex-editor :editor_data.sync="privacy_form_message"/>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col w-full mb-2">
            <b-form-group
                :label="$t('receiving_emails')"
                label-for="emailsInput">
              <validation-provider
                #default="{ errors }"
                name="emailsInput">
                <!--Tags input-->
                <emails-input
                  ref="emailsInput"
                  :emailsInput="emailsInitialTag"
                  @emailsChanged="emailsChanged"
                  :sendButton="false"/>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </div>
        </div>

        <!--ACTIONS -->
        <div class="flex justify-end mb-4">
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            class="float-right mr-1"
            type="submit">
            Salvar
          </b-button>
          <b-button
              variant="outline-secondary"
              class="float-right"
              @click="goBack">
              <feather-icon
                icon="CornerUpLeftIcon"
                class="mr-50"/>
              <span class="align-middle">{{$t('back')}}</span>
          </b-button>
        </div>
        <b-card-code
          :key="id"
          title="URL Interna"
          codeVisible="true"
          showCopy="true"
          codeEmbed="true">
          <b-card-text>
            Use esta URL para direcionar o usuário para o formulário de requisição LGPD em sua INTRANET.
          </b-card-text>
          <template #code>
            {{ internalPrivacyUrl }}
          </template>
        </b-card-code>
        <b-card-code
          :key="id"
          title="URL Externa"
          codeVisible="true"
          showCopy="true"
          codeEmbed="true"
          :shortUrl="shortUrl">
          <b-card-text>
            Use esta URL para direcionar o usuário para o formulário de requisição LGPD em sua EXTRANET.
          </b-card-text>
          <template #code>
            {{ externalPrivacyUrl }}
          </template>
        </b-card-code>
        <b-card-code
          :key="id"
          title="Protocolo - Página de Consulta Pública"
          codeVisible="true"
          showCopy="true"
          codeEmbed="true">
          <b-card-text>
            Use esta URL para realizar consulta da situação e tratamento do formulário de requisição LGPD.
          </b-card-text>
          <template #code>
            {{ protocolQueryUrl }}
          </template>
        </b-card-code>

    </b-form>
  </div>
</template>

<script>
import {
  BForm, BButton, BFormGroup, BInputGroup, BFormTextarea, BCardText, BFormInput
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import BCardCode from '@core/components/b-card-code'
import ComplexEditor from '@/components/ComplexEditor.vue'
import EmailsInput from '@/components/EmailsInput.vue'

import LegalEntityFormLgpdService from '@/services/api/LegalEntityFormLgpdService'

export default {
  components: {
    BForm,
    BButton,
    BFormGroup,
    BInputGroup,
    BFormTextarea,
    BCardCode,
    BCardText,
    BFormInput,
    // validations
    ValidationProvider,
    ValidationObserver,
    ComplexEditor,
    EmailsInput
  },
  props: {
    legalEntityId: {
      type: Number,
      default: null
    },
  },
  data: () => ({
    legalEntity: null,
    privacy_form_description: '',
    privacy_form_link: '',
    privacy_form_message: '',
    emails: [],
    emailsInitialTag: [],
  }),
  watch: {
    //Não retirar, verificar a lógica da consulta da legalEntity
    '$store.state.legalEntity.legalEntity'(legalEntity) {
      this.legalEntity = legalEntity
      this.fillLegalEntityFormLgpd()
    }
  },
  computed: {
    internalPrivacyUrl() {
      if (this.legalEntity && this.legalEntity.internal_privacy_url) {
        return `${this.legalEntity.internal_privacy_url}`
      }
      return ''
    },
    externalPrivacyUrl() {
      if (this.legalEntity && this.legalEntity.external_privacy_url) {
        return `${this.legalEntity.external_privacy_url}`
      }
      return ''
    },
    shortUrl(){
      if (this.legalEntity && this.legalEntity.privacy_short_url) {
        return `${this.legalEntity.privacy_short_url}`
      }
      return null
    },
    protocolQueryUrl() {
      if (this.legalEntity && this.legalEntity.privacy_protocol_query_url) {
        return `${this.legalEntity.privacy_protocol_query_url}`
      }
      return 'unknown'
    },
  },
  methods: {
    save() {
      this.clearErrors(this.$validator)
      this.$vs.loading()

      const legalEntityFormLgpdId = _.get(this.legalEntity, 'legal_entity_form_lgpd_id')
      const params = {
        id: legalEntityFormLgpdId,
        legal_entity_id: this.legalEntityId,
        privacy_form_description: this.privacy_form_description ? this.privacy_form_description : '',
        privacy_form_link: this.privacy_form_link ? this.privacy_form_link : '',
        privacy_form_message: this.privacy_form_message ? this.privacy_form_message : '',
        emails: this.emails
      }

      this.legalEntityFormLgpdService.createOrUpdate(params).then(
        data => {
          this.legalEntity.legal_entity_form_lgpd_id = data.id
          this.$vs.loading.close()
          this.notifySuccess(this.$vs)
        },
        error => {
          this.$vs.loading.close()
          this.notifyError(this.$vs, 'Erro! não foi possível concluir esta operação')
        }
      )
    },
    fillLegalEntityFormLgpd() {
      if (this.legalEntity) {
        this.privacy_form_description = _.get(this.legalEntity, 'legal_entity_form_lgpd.privacy_form_description')
        this.privacy_form_link = _.get(this.legalEntity, 'legal_entity_form_lgpd.privacy_form_link')
        this.privacy_form_message = _.get(this.legalEntity, 'legal_entity_form_lgpd.privacy_form_message')
        this.emails = _.get(this.legalEntity, 'legal_entity_form_lgpd.data.emails')
        this.emailsInitialTag = this._.cloneDeep(this.emails)
      }
    },
    goBack() {
      this.$store.commit('legalEntity/UPDATE_LEGAL_ENTITY', null)
      this.$router.push({name: 'people-legal-entities'})
    },
    emailsChanged(emails) {
      this.emails = emails
    }
  },
  beforeMount() {
    this.legalEntityFormLgpdService = LegalEntityFormLgpdService.build(this.$vs)
  },
  mounted() {
    const legalEntity = this.$store.getters['legalEntity/legalEntity']
    if (legalEntity) {
      this.legalEntity = legalEntity
      this.fillLegalEntityFormLgpd()
    }
    if (this.legalEntityId) {
      //this.getData(this.legalEntityId)
    }
  },
  beforeDestroy() {
    this.destroyChilds(this)
  }
}
</script>

<style lang="scss">
  @import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
